// extracted by mini-css-extract-plugin
export var menuIcon = "_ov-0";
export var menuIconInline = "_ov-1";